export default "__VITE_ASSET__fv0zpGmk__"